import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'usersStatusPipe'
})
export class UserStatusPipe implements PipeTransform {

  private listObj = {
    0: 'Pending Verification',
    1: 'Initial Login',
    2: 'Activated',
    3: 'Deactivated',
  };

  transform(value: number): string {
    console.log("transforming: ", value)
    return this.listObj.hasOwnProperty(value) ? this.listObj[value] : '';
  }

}
